// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"About_pageContent__3rC25","subtitle":"About_subtitle__3bttr"};